import { VideoMirrorEndEvent, VideoMirrorStartEvent } from '../../types'
import { ReplayerCurrentTime } from '../ReplayerProxy'
import { LoggerName, namedLogger } from '../../../../../../utils/logger'

const logger = namedLogger(LoggerName.videoMirrorUtils)

/**
 * returns the most recent event recorded for a video for a given moment in time. If the replayerCurrentTime is before a video has started, it returns nothing
 * @param mirrorName
 * @param videoMirrorEvents
 * @param replayerCurrentTime
 */
export function getMostRecentVideoMirrorEvent(
  mirrorName: string,
  videoMirrorEvents: Array<VideoMirrorStartEvent | VideoMirrorEndEvent>,
  replayerCurrentTime: ReplayerCurrentTime
): VideoMirrorStartEvent | VideoMirrorEndEvent | undefined {
  logger.debug('getMostRecentVideoMirrorEvent - mirrorName', mirrorName, '- replayerCurrentTime', { console: replayerCurrentTime })
  if (videoMirrorEvents) {
    let latestEventTime: number | undefined
    let latestEvent: VideoMirrorStartEvent | VideoMirrorEndEvent | undefined
    const previousEvents = videoMirrorEvents.filter(e => e.videoMirrorPlaceholderName === mirrorName && e.eventTime <= replayerCurrentTime.epoch)
    for (const event of previousEvents) {
      if (!latestEventTime || event.eventTime > latestEventTime) {
        latestEventTime = event.eventTime
        latestEvent = event
      }
    }
    logger.debug('getMostRecentVideoMirrorEvent - latestEvent', { console: latestEvent })
    return latestEvent
  }
}
